import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';


@Component({
  selector: 'okay-modal',
  templateUrl: './okay-modal.html',
  styleUrls: ['./okay-modal.scss'],
})
export class CkycOkayModel {

  showLoader = false;
  @Input() onReturn: () => void;
  @Input() ckycFlag: any;
  constructor() { }

  handleContinue() {
    if (this.onReturn) {
      this.showLoader = true
      this.onReturn();
    }
  }


}